import React, { useEffect } from 'react'
import TextField from '../../../core/common/textFields/TextField'
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { useGetCompanyInfoQuery, useUpdateCompanyInfoMutation } from '../../../services/EndPointsApis';
import { InputMask } from '@react-input/mask';
import { inputMaskNumber } from '../../../core/common/textFields/NumberField';

const CompanyInfo = () => {

    const initialValues = {
        id: 0,
        address1: "",
        address2: "",
        phoneNo1: "",
        phoneNo2: ""
    };
    const [UpdateCompanyInfo, { data, isError, error, isSuccess, isLoading }] =
        useUpdateCompanyInfoMutation();

    const { data: getCompanyInfo, refetch, isSuccess: getIsSuccess } = useGetCompanyInfoQuery('');

    const formik = useFormik({
        initialValues,
        onSubmit: (values) => {
            UpdateCompanyInfo(values);
        }

    })

    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            refetch()
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error]);

    useEffect(() => {
        if (getCompanyInfo?.result) {
            formik.setValues({ ...getCompanyInfo?.result })
        }

    }, [getCompanyInfo?.result])

    useEffect(() => {
        refetch()
    }, [])


    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className='row'>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="Company Address 1"
                                type="text"
                                {...formik.getFieldProps("address1")}
                            // disabled={viewOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="Company Address 2"
                                type="text"
                                {...formik.getFieldProps("address2")}
                            // disabled={viewOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <div className="form-wrap">
                                <label className='input-label'>
                                    Company Phone 1
                                </label>
                                <InputMask mask={inputMaskNumber}
                                    replacement={{ _: /\d/ }}
                                    className='form-control'
                                    {...formik.getFieldProps("phoneNo1")}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <div className="form-wrap">
                                <label className='input-label'>
                                    Company Phone 2
                                </label>
                                <InputMask mask={inputMaskNumber}
                                    replacement={{ _: /\d/ }}
                                    className='form-control'
                                    {...formik.getFieldProps("phoneNo2")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="submit-button d-flex justify-content-end mt-3">
                    <button type="submit" className="btn btn-primary">
                        Change Info
                    </button>
                </div>
            </form>
        </>
    )
}

export default CompanyInfo